module.exports = __webpack_public_path__ + "static/7-98fe27072801822c9eabab673cc118b9.png";